/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateOnboardingInviteGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type CreateOnboardingInviteResponse = {
  headers: { [k: string]: Array<string> };
  result: components.OnboardingInvite;
};

/** @internal */
export const CreateOnboardingInviteGlobals$inboundSchema: z.ZodType<
  CreateOnboardingInviteGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type CreateOnboardingInviteGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const CreateOnboardingInviteGlobals$outboundSchema: z.ZodType<
  CreateOnboardingInviteGlobals$Outbound,
  z.ZodTypeDef,
  CreateOnboardingInviteGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function createOnboardingInviteGlobalsToJSON(
  createOnboardingInviteGlobals: CreateOnboardingInviteGlobals,
): string {
  return JSON.stringify(
    CreateOnboardingInviteGlobals$outboundSchema.parse(
      createOnboardingInviteGlobals,
    ),
  );
}
export function createOnboardingInviteGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<CreateOnboardingInviteGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateOnboardingInviteGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateOnboardingInviteGlobals' from JSON`,
  );
}

/** @internal */
export const CreateOnboardingInviteResponse$inboundSchema: z.ZodType<
  CreateOnboardingInviteResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.OnboardingInvite$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type CreateOnboardingInviteResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.OnboardingInvite$Outbound;
};

/** @internal */
export const CreateOnboardingInviteResponse$outboundSchema: z.ZodType<
  CreateOnboardingInviteResponse$Outbound,
  z.ZodTypeDef,
  CreateOnboardingInviteResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.OnboardingInvite$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function createOnboardingInviteResponseToJSON(
  createOnboardingInviteResponse: CreateOnboardingInviteResponse,
): string {
  return JSON.stringify(
    CreateOnboardingInviteResponse$outboundSchema.parse(
      createOnboardingInviteResponse,
    ),
  );
}
export function createOnboardingInviteResponseFromJSON(
  jsonString: string,
): SafeParseResult<CreateOnboardingInviteResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateOnboardingInviteResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateOnboardingInviteResponse' from JSON`,
  );
}
